import ContentConfig from '../../../config/ContentConfig';
import { ConstructedEvents, MonitoredMediaEvents } from '../constants';
import { EventReport, PlayerEventReporter } from './interfaces';

const { resolutionchanged } = ConstructedEvents;
const { resize } = MonitoredMediaEvents;

// Map so we can get the field to test against.
const codeToMetadata = {
  [resolutionchanged.code]: resolutionchanged.metadata,
  [resize.code]: resize.metadata
};
type VideoField = 'vr' | 'cr';

/**
 * Check if an event is a resolution change type event and handle it if it is
 *
 * @param event - the event to handle
 * @param reporter - the reporter object
 * @returns true if the event is handled
 */
const resolutionChangeHandler = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  const field = codeToMetadata[event.e] as VideoField;
  if (typeof field === 'undefined') {
    return false;
  }
  if (!ContentConfig.getInstance().report.enableEngagementEvent) {
    return true;
  }
  const eventState = reporter.localState.event;
  if (!event[field] || (event[field] === eventState[field] && !event.s)) {
    return true;
  }
  eventState[field] = event[field];
  reporter.pending.events.data.push(event);
  return true;
};

export default resolutionChangeHandler;
